const PaymentMode = {
  accountcredit: "accountcredit",
  card: "card",
  mkbszep: "mkbszep",
  otpszep: "otpszep",
  knhszep: "knhszep",
  otopszepszallas: "optszepszallas",
  mkbszepszallas: "mkbszepszallas",
  free: "free"
};

const ShippingMode = {
  ship: "ship",
  eticket: "eticket"
};

const CartPrecheckStatus = {
  success: "mehet",
  failure: "nemmehet",
  couponExpired: "kuponlejart",
  codeExpired: "kodlejart",
  error: "error",
  invalid: "invalid"
};
const CartPrecheckStatusEnglish = {
  success: "success",
  failure: "fail",
  couponExpired: "couponexpired",
  codeExpired: "codeexpired",
  error: "error",
  invalid: "invalid"
};

const CartStatus = {
  cart: "cart",
  queue: "queue",
  wait: "wait",
  error: "error",
  soldout: "soldout",
  onecart: "onecart",
  alternate: "alternate",
  couponused: "couponused"
};
const CartQueueAlternateChoices = {
  Remaining: "remaining",
  Alternate: "alternate",
  Remove: "remove"
};

var Gender = /* @__PURE__ */ ((Gender2) => {
  Gender2["MALE"] = "male";
  Gender2["FEMALE"] = "female";
  return Gender2;
})(Gender || {});

const OrderStatus = {
  success: "mehet",
  failure: "nemmehet",
  couponExpired: "kuponlejart",
  codeExpired: "kodlejart",
  couponUsed: "kuponhasznalt"
};

const PaymentStatus = {
  success: "success",
  failure: "failure",
  pending: "pending"
};

const RefundOption = {
  Keep: "keep",
  Voucher: "voucher",
  Refund: "refund",
  Exchange: "exchange"
};

const RefundProductOption = {
  WithAddress: "withAddress",
  WithoutAddress: "withoutAddress"
};

const LoginStatus = {
  success: "authorized",
  unknown: "unauthorized",
  unlinked: "identity_provider_unlinked"
};

const IdentityProvider = {
  facebook: "facebook"
};

const RecoveryEmailStatus = {
  success: "sent",
  unknown: "unknown"
};

const RecoveryStatus = {
  success: "success",
  unknown: "unknown"
};

const RegistrationStatus = {
  success: "success",
  emailExists: "emailExists",
  weakPass: "weakPass"
};

const EventSaleStatus = {
  soon: "soon",
  codeonly: "codeonly",
  onsale: "onsale",
  soldout: "soldout",
  closed: "closed",
  unavailable: "unavailable"
};

const FeatureToggle = {
  NewWaitingRoomEndpoints: "new-waitingroom-endpoints",
  EnglishWaitingRoomEndpoints: "english-waitingroom-endpoints",
  DisableImpressionCalls: "disable-impression-calls",
  DisableWaitingRoomIdentification: "disable-waitingroom-identification",
  NewLoginEndpoints: "new-login-endpoints",
  NewCartEndpoints: "new-cart-endpoints",
  NewOrderEndpoints: "new-order-endpoints",
  NewLanguageEndpoint: "new-language-endpoint",
  DisableGoogleMaps: "disable-googlemaps",
  DisableAnalytics: "disable-analytics",
  DisableErrorReporting: "disable-error-reporting",
  RelayFacebookEvents: "relay-facebook-events"
};

const OfferAvailability = {
  Discontinued: "http://schema.org/Discontinued",
  InStock: "http://schema.org/InStock",
  InStoreOnly: "http://schema.org/InStoreOnly",
  LimitedAvailability: "http://schema.org/LimitedAvailability",
  OnlineOnly: "http://schema.org/OnlineOnly",
  OutOfStock: "http://schema.org/OutOfStock",
  PreOrder: "http://schema.org/PreOrder",
  PreSale: "http://schema.org/PreSale",
  SoldOut: "http://schema.org/SoldOut"
};

export { CartPrecheckStatus, CartPrecheckStatusEnglish, CartQueueAlternateChoices, CartStatus, EventSaleStatus, FeatureToggle, Gender, IdentityProvider, LoginStatus, OfferAvailability, OrderStatus, PaymentMode, PaymentStatus, RecoveryEmailStatus, RecoveryStatus, RefundOption, RefundProductOption, RegistrationStatus, ShippingMode };
//# sourceMappingURL=tixa-schema.js.map
